'use client';

import Link from 'next/link';
import { Search, Home } from 'lucide-react';
import { useTranslation } from '@/i18n';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-6 px-4">
        <div className="space-y-1">
          <p className="text-sm font-semibold tracking-widest text-primary uppercase">
            Agilora
          </p>
          <h1 className="text-7xl font-bold text-foreground">404</h1>
        </div>

        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-foreground">
            {t('errors.page.notFound')}
          </h2>
          <p className="text-muted-foreground max-w-sm mx-auto">
            {t('errors.page.notFoundMessage')}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground shadow-sm hover:bg-primary/90 transition-colors"
          >
            <Home className="h-4 w-4" />
            {t('errors.page.notFoundBackHome')}
          </Link>
          <Link
            href="/search"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-input px-6 py-2.5 text-sm font-medium text-foreground shadow-sm hover:bg-accent transition-colors"
          >
            <Search className="h-4 w-4" />
            {t('errors.page.notFoundSearch')}
          </Link>
        </div>
      </div>
    </div>
  );
}
